<template>
  <div>
    <fetch-json :url="url">
      <template slot-scope="{ json: doc, loading }">
        <custom-scroll v-if="!loading && doc">
          <div class="object-card-content">
            <div class="object-card-content__props">
              <h5 class="title is-5">{{ doc.name }}</h5>
              <slot :doc="doc"></slot>
              <property name="Номер документа" :value="doc.docNum"> </property>
              <property name="Дата документа" :value="doc.dateDoc"> </property>
              <property
                name="Регистрационный номер в ГИСОГД"
                :value="doc.numReg"
              >
              </property>
              <property name="Дата регистрации в ГИСОГД" :value="doc.dateReg">
              </property>
              <property
                name="Наименование органа, утвердившего документ"
                :value="doc.approvedOrganization"
              >
              </property>
              <component :is="docBoundary" :doc="doc"></component>

              <div v-if="doc.docsAboutTP && doc.docsAboutTP.length">
                <ul class="files-list">
                  <GisogdDocumentAboutTP
                    v-for="docAboutTP in doc.docsAboutTP"
                    :key="docAboutTP.name"
                    :docAboutTP="docAboutTP"
                    :projectSchema="projectSchema"
                  ></GisogdDocumentAboutTP>
                </ul>
              </div>

              <div v-if="doc.textFiles && doc.textFiles.length">
                <p class="has-text-grey">Документы:</p>
                <FileList :files="doc.textFiles" />
              </div>
            </div>
            <div class="object-card-content__map" v-if="showInfosetGeometry">
              <PropertyLabel
                name="Территория действия документа"
              ></PropertyLabel>
              <slot
                name="map"
                :doc="doc"
                class="object-card-content__map"
              ></slot>
            </div>
          </div>
        </custom-scroll>
      </template>
    </fetch-json>
  </div>
</template>
<script>
import Property from '@/components/common/Property';
import PropertyLabel from '@/components/common/PropertyLabel';
import GisogdDocumentAboutTP from '@/components/documents/GisogdDocumentAboutTP';
import ZuDocBoundary from '@/components/documents/docboundary/ZuDocBoundary';
import SettlementDocBoundary from '@/components/documents/docboundary/SettlementDocBoundary';
import TerritoryDocBoundary from '@/components/documents/docboundary/TerritoryDocBoundary';
import FileList from '@/components/documents/FileList';

export default {
  props: {
    projectSchema: {
      type: String,
      required: true,
    },
    doc: {
      type: Object,
      required: true,
    },
    showInfosetGeometry: {
      default: false,
    },
  },
  components: {
    FileList,
    Property,
    PropertyLabel,
    GisogdDocumentAboutTP,
    ZuDocBoundary,
    SettlementDocBoundary,
    TerritoryDocBoundary,
  },
  computed: {
    docBoundary() {
      switch (this.doc.gisogdSection) {
        case 'razdel3':
        case 'razdel4':
        case 'razdel5':
          return 'SettlementDocBoundary';
        case 'razdel7':
          return 'TerritoryDocBoundary';
        case 'razdel13':
          return 'ZuDocBoundary';
        default:
          return null;
      }
    },
    url() {
      return `v1/${this.projectSchema}/gisogddocs/${this.doc.gisogdSection}/${
        this.doc.key
      }`;
    },
  },
};
</script>
<style scoped>
.object-card-content {
  display: flex;
}
.object-card-content__props {
  flex: 1;
}
.object-card-content__map {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
